import React from "react";

import PropTypes from "prop-types";
import ReactPaginate from "react-paginate";
import styled from "styled-components";

import Icon from "../../Icon/Icon";
import useDevice from "../../customHooks/useDevice";

const StyledReactPaginate = styled(ReactPaginate)`
  li {
    transition: background-color 0.2s ease;
    a {
      text-decoration: none;
      color: ${({ theme }) => `${theme.primaryBackgroundColor}`};
      transition: color 0.2s ease;
      font-weight: bold;
      padding: 0.3rem 1rem;
    }
  }

  .active a {
    color: ${({ theme }) => `${theme.negativeTextColor}`};
  }

  .previous,
  .next {
    flex: 0 0 20%;
    text-align: center;
    border: 1px solid ${({ theme }) => `${theme.primaryBackgroundColor}`};
    a {
      display: block;
      padding: 0.5rem;
    }
  }

  .previous {
    &:hover {
      background-color: ${({ theme }) => `${theme.primaryBackgroundColor}`};

      a {
        color: ${({ theme }) => `${theme.negativeTextColor}`};
      }
    }
  }

  .next {
    background-color: ${({ theme }) => `${theme.primaryBackgroundColor}`};

    a {
      color: ${({ theme }) => `${theme.negativeTextColor}`};
    }

    &:hover {
      background-color: transparent;
      a {
        color: ${({ theme }) => `${theme.primaryBackgroundColor}`};
      }
    }
  }

  .disabled {
    pointer-events: none;
    border: none !important;
    background-color: var(--bs-gray-200);

    a {
      pointer-events: none;
      color: var(--bs-gray-500);
    }
  }

  .selected {
    a {
      border-bottom: 1px solid currentColor;
    }
  }
`;

const IconLeft = <Icon color="black" icon="chevronLeft" size={16} />;
const IconRight = <Icon color="black" icon="chevronRight" size={16} />;

function StyledPagination(props) {
  const { handlePageClick, pageCount } = props;
  const { isMobile } = useDevice();

  const pageRangeDisplayed = isMobile ? 2 : 5;
  const marginPagesDisplayed = isMobile ? 1 : 3;
  const previousLabel = isMobile ? IconLeft : "PREVIOUS";
  const nextLabel = isMobile ? IconRight : "NEXT";

  return (
    <StyledReactPaginate
      breakLabel="..."
      className="d-flex justify-content-between list-unstyled align-items-center"
      marginPagesDisplayed={marginPagesDisplayed}
      nextLabel={nextLabel}
      onPageChange={handlePageClick}
      pageCount={pageCount}
      pageRangeDisplayed={pageRangeDisplayed}
      previousLabel={previousLabel}
      renderOnZeroPageCount={false}
    />
  );
}

export default StyledPagination;

StyledPagination.propTypes = {
  handlePageClick: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
};
